import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
export const InputTextItems = memo((props) => {
    const { list, placeholder = Array.from(list, () => ''), disabled, onChange } = props;
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null, list.map((value, index) => {
        return (React.createElement(Grid, { key: index, item: true, xs: 12, md: 6 },
            React.createElement(TextField, { placeholder: !disabled ? t(placeholder[index]) : '', value: value, onChange: (e) => onChange(index, e.target.value), disabled: disabled, fullWidth: true })));
    })));
});
